import { useEffect, useState} from 'react';
import axios from '../../axios.js';
import CircularProgress  from '@mui/material/CircularProgress';
import { useLocation, useNavigate } from "react-router-dom";

import Results from '../../components/Results/Results';
import Pager from '../../components/Pager/Pager';
import SearchBar from '../../components/SearchBar/SearchBar';
//import { useMediaQuery } from '@mui/material';
//import { useTheme } from '@mui/material/styles';

import "./Search.css";


export default function Search_MRMR() {
  
  let location = useLocation();
  const navigate = useNavigate();
  //const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  
  const [ results, setResults ] = useState([]);
  const [ resultCount, setResultCount ] = useState(0);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ q, setQ ] = useState(new URLSearchParams(location.search).get('q') ?? "*");
  const [ top ] = useState(new URLSearchParams(location.search).get('top') ?? 10);
 // const [ skip, setSkip ] = useState(new URLSearchParams(location.search).get('skip') ?? 0);
 let skip = (currentPage - 1) * top;
  const [ filters, setFilters ] = useState([]);
  const [ facets, setFacets ] = useState({});
  const [ isLoading, setIsLoading ] = useState(true);
  const [sortDate, setSortDate] = useState(false);

  let resultsPerPage = top;
  
  useEffect(() => {
    setIsLoading(true);

    //setSkip((currentPage-1) * top);
    const body = {
      q: q,
      top: top,
      skip: skip,
      filters: [{'field':'source','value':"Standard, Leading Practices & Guidance"}],
      sortDate: sortDate,
      isFrench: false,
    };

    axios.post( '/api/search', body)
      .then(response => {
            setResults(response.data.result.results);
            setFacets(response.data.result.facets);
            setResultCount(response.data.result.count);
            setIsLoading(false);
        } )
        .catch(error => {
            console.log(error);
            setIsLoading(false);
        });
    
  }, [q, top, filters, skip,currentPage, sortDate]);

  // pushing the new search term to history when q is updated
  // allows the back button to work as expected when coming back from the details page
  useEffect(() => {
    navigate('/search-mrmr?q=' + q);  
    setCurrentPage(1);
    setFilters([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);


  const postSearchHandler = async (searchTerm) => {
    //const word = await checkSpelling(searchTerm);
    setQ(searchTerm);
  };


  var body;
  if (isLoading) {
    body = (
  <div
    style={{
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: '5%',
  }}
>
  <CircularProgress style={{ color: '#00a1dd' }} />
</div>);
  } else {
    body = (
      <div className="col-md-12">
        <Results documents={results} top={top} skip={skip} count={resultCount} query={q} sortDate={sortDate} setSortDate={setSortDate} color={"#00a1dd"}></Results>
        <Pager className="pager-style" currentPage={currentPage} resultCount={resultCount} resultsPerPage={resultsPerPage} setCurrentPage={setCurrentPage} color={"#00a1dd"}></Pager>
      </div>
    )
  }


  return (
 <main className="container-fluid px-4 py-3">
    {/* Top Search Bar */}
    <div className="row mb-4">
      <div className="col-12">
        <div className="d-flex">
          <SearchBar postSearchHandler={postSearchHandler} query={q}  facets = {facets} filters={filters} setFilters={setFilters} color={"#00a1dd"} source={'mrmr-eng'}/>
          {/* Optional search button if SearchBar doesn’t include it */}
          {/* <button className="btn btn-primary ms-2">Search</button> */}
        </div>
      </div>
    </div>
  
    {/* Main content area: 70% body, 30% facets */}
    <div className="row">
      {/* Left: Body content (70%) */}
      <div className="col-md-12">
        {body}
      </div>
    </div>
  </main>
  
  );
}
